module.exports = __webpack_public_path__ + "static/img/pc-hidechat.f64d14d8.png";